import request from '@/utils/request'

/**
 * 提现分页
 */
export function page(data) {
	return request({
		url: '/withdrawal/get/page',
		method: 'post',
		headers: {
			"Content-Type": "application/json;charset=UTF-8"
		},
		data: data,
	})
}

/**
 * 申请提现
 */
export function apply(data) {
	return request({
		url: '/withdrawal/apply',
		method: 'post',
		headers: {
			"Content-Type": "application/json;charset=UTF-8"
		},
		data: data,
	})
}
